import { render, staticRenderFns } from "./UpdateProfileComponent.vue?vue&type=template&id=74ba9a1a"
import script from "./UpdateProfileComponent.vue?vue&type=script&lang=js"
export * from "./UpdateProfileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports